var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._t("listSelectionControls"),_c('td',[_vm._v(" "+_vm._s(_vm.object.name)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.tagCategory)+" ")]),_c('td',[_vm._v(" "+_vm._s(_vm.object.wikipedia)+" ")]),_vm._t("defaultAvailableActions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }